
import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Button,
  Modal,
  ModalBody,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  ModalHeader,
  Col
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
// import MMO from "./add-mmo";
import Bank from "./add-bank";
import { useToasts } from 'react-toast-notifications';
import { getMethod, postMethod } from "../../services/httpServices";
import FullPageLoader from "components/FullPageLoader/fullpageloader";
import NoRecordFound from "components/NoRecordFound/NoRecordFound";
import ViewBank from './view-bank';
import EditBank from './edit-bank';
import { bankType, btnCss, iconCss } from "appConfig";
import ReactPaginate from 'react-paginate';
import { getSortCls } from "services/util";
import { getPrivileges } from "services/util";


const BANKTYPE = bankType;

const sortIS = {
  sortName: 0,
  sortEmail: 0,
  sortPhone: 0
};

const BankList = () => {

  const [open, setOpen] = React.useState(false);
  const [banklist, setBankList] = React.useState([]);
  const [filteredList, setFilteredList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [pagesCount, setPageCount] = React.useState(0);
  const [timeout, setTimeoutNew] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [bankObj, setBankObj] = React.useState(null);
  const [view, setView] = React.useState(false);
  const [openEdit, setOpenEditModal] = React.useState(false);
  const [editObj, setEditObj] = React.useState(null);
  const [deleteObj, setDeleteObj] = React.useState(null);
  const [openDelModal, setOpenDelModal] = React.useState(false);
  const [bankTypeFilter, setBankTypeFiler] = React.useState(BANKTYPE[0].key);
  const [totalList, setTotalList] = React.useState([]);
  const [modalLoading, setModalLoading] = React.useState(false);
  const [searchText, setSearchText] = React.useState('');
  const [refresh, setRefresh] = React.useState(false);
  const [totalRec, setTotalRec] = React.useState(0);
  const [sort, setSort] = React.useState(sortIS);
  const [isMounted, setIsMounted] = React.useState(false);

  const { addToast } = useToasts();
  const privileges = getPrivileges('bank');

  const openModal = () => {
    setOpen(true);
  }

  const closeModal = () => {
    setOpen(false);
    fetchBank();
  }

  // React.useEffect(() => {
  //   // fetch mobilemoney operator
  //   fetchBank();
  // }, []);

  React.useEffect(() => {
    if (!refresh && isMounted) {
      if (currentPage == 0) {
        fetchBank();
      } else {
        setCurrentPage(0);
      }
    }
  }, [bankTypeFilter]);

  React.useEffect(() => {
    if (!refresh && isMounted) {
      if (
        searchText && searchText.length >= 3 ||
        searchText.length == 0
      ) {
        fetchBank();
      }
    }
  }, [searchText]);


  React.useEffect(() => {
    fetchBank();
  }, [currentPage]);

  React.useEffect(() => {
    if (!refresh && isMounted) {
      if (currentPage != 0) {
        setCurrentPage(0);
      } else {
        fetchBank();
      }
    }
  }, [sort]);

  React.useEffect(() => {
    if (refresh && isMounted) {
      setSearchText('');
      setSort(sortIS);
      if (currentPage == 0) {
        fetchBank();
      } else {
        setCurrentPage(0);
      }
    }
  }, [refresh]);


  const notifyFailed = (text) => {
    if (!text) {
      text = 'Error in saving';
    }
    addToast(text, {
      appearance: 'error',
      autoDismiss: true,
    });
  }

  const notifySuccess = (text) => {
    if (!text) {
      text = 'Save successfully';
    }
    addToast(text, {
      appearance: 'success',
      autoDismiss: true,
    });
  }

  const handleClick = (e, index) => {

    e.preventDefault();
    setCurrentPage(index);

  }

  const getSearchHandle = (val, blist) => {
    let banklist = blist;
    let filteredList = [];
    for (let i = 0; i < banklist.length; i++) {
      if (
        (banklist[i].bankName
          .trim()
          .toLowerCase()
          .includes(val.trim().toLowerCase())) ||
        (banklist[i].contactEmail
          .trim()
          .toLowerCase()
          .includes(val.trim().toLowerCase())) ||
        (banklist[i].contactMobileCode.toString()
          .trim()
          .toLowerCase()
          .includes(val.trim().toLowerCase())) ||
        (banklist[i].contactMobileNumber.toString()
          .trim()
          .toLowerCase()
          .includes(val.trim().toLowerCase())) ||
        (banklist[i].centralBankIdentificationNo.toString()
          .trim()
          .toLowerCase()
          .includes(val.trim().toLowerCase()))
      ) {
        filteredList.push(banklist[i]);
      }
    }
    return filteredList;
  }

  const getSearch = (val) => {
    setSearchText(val);
    // if (timeout) clearTimeout(timeout);
    // const timeout1 = setTimeout(() => {
    //   let filteredList = getSearchHandle(val, banklist);
    //   setFilteredList(filteredList);
    //   setCurrentPage(0);
    //   let pc = Math.ceil(filteredList.length / pageSize);
    //   setPageCount(pc);
    // }, 750);
    // setTimeoutNew(timeout1);
  };

  const showBank = (obj) => {
    setBankObj(obj);
    setView(true);
  }

  const closeViewModal = () => {
    setView(false);
    // setBankObj(null);
  }

  const closeEditModal = () => {
    setOpenEditModal(false);
    // setEditObj(null);
    fetchBank();
  }

  const openDelete = (mmo) => {
    setDeleteObj(mmo);
    setOpenDelModal(true);
  }

  const closeDeleteModal = () => {
    setDeleteObj(null);
    setOpenDelModal(false);
  }


  const fetchBank = async () => {
    let errorMsg = '';
    setLoading(true);

    let data = {
      'PageNumber': Number(currentPage + 1),
      'PerPage': pageSize,
      'AccountType': bankTypeFilter
    };

    if (searchText && searchText.length >= 3) {
      data['SearchText'] = searchText;
      // data['PageNumber'] = 0;
    }

    if (sort.sortName == "1") {
      data['SortingOn'] = 'BankName';
      data['IsDescending'] = false;
    } else if (sort.sortName == "2") {
      data['SortingOn'] = 'BankName';
      data['IsDescending'] = true;
    } else if (sort.sortEmail == "1") {
      data['SortingOn'] = 'ContactEmail';
      data['IsDescending'] = false;
    } else if (sort.sortEmail == "2") {
      data['SortingOn'] = 'ContactEmail';
      data['IsDescending'] = true;
    } else if (sort.sortPhone == "1") {
      data['SortingOn'] = 'MobNumber';
      data['IsDescending'] = false;
    } else if (sort.sortPhone == "2") {
      data['SortingOn'] = 'MobNumber';
      data['IsDescending'] = true;
    }

    postMethod('/api/BankProfile/AllBank', data, 'post')
      .then(res => {
        setLoading(false);
        setRefresh(false);
        setIsMounted(true);
        if (
          res && res.data
        ) {
          if (res.data.responseCode === "200" &&
            res.data.result) {
            // Success
            if (
              !res.data.result.list ||
              !res.data.result.list.length
            ) {
              res.data.result.list = [];
            }
            setBankList(res.data.result.list);
            setFilteredList(res.data.result.list)
            let pc = Math.ceil(res.data.result.totalRecords / pageSize);
            setTotalRec(res.data.result.totalRecords);
            setPageCount(pc);
          } else if (res.data.responseCode === "400") {
            // Error
            errorMsg = res.data.responseMessage || 'Error in fetching list';
            notifyFailed(errorMsg);
          } else {
            // Unknown Error
            errorMsg = 'Unknown Error in fetching';
            notifyFailed(errorMsg);

          }
        } else {
          errorMsg = 'Unknown Error';
          notifyFailed(errorMsg);

        }
      }).catch(err => {
        setRefresh(false);
        setLoading(false);
        setIsMounted(true);
        notifyFailed('Internal Server Error');
      })
  }

  const fetchBankById = (id) => {
    let errorMsg = '';
    postMethod('/api/BankProfile/Edit/' + id, {}, 'post')
      .then(res => {
        if (
          res && res.data
        ) {
          if (res.data.responseCode === "200") {
            // Success
            setEditObj(res.data.result);
            setOpenEditModal(true);
          } else if (res.data.responseCode === "400") {
            // Error
            errorMsg = res.data.responseMessage || 'Error in fetching list';
            // setSError(errorMsg);
            notifyFailed(errorMsg);
          } else {
            // Unknown Error
            errorMsg = 'Unknown Error in fetching';
            // setSError(errorMsg);
            notifyFailed(errorMsg);
          }
        } else {
          errorMsg = 'Unknown Error';
          // setSError(errorMsg);
          notifyFailed(errorMsg);
        }
      }).catch(err => {
        // setSError();
        notifyFailed('Internal Server Error');
      });
  }


  const deleteBank = () => {
    let errorMsg = '';
    setModalLoading(true);
    let url = '/api/User/block/' + deleteObj.userProfileId;
    postMethod(url, {}, 'post')
      .then(res => {
        setModalLoading(false);
        if (
          res && res.data
        ) {
          if (res.data.responseCode === "200") {
            // Success
            let text = deleteObj.isBlocked ? 'Bank unblocked successfully' :
              'Bank blocked succsessfully';
            notifySuccess(text);
            closeDeleteModal();
            fetchBank();
          } else if (res.data.responseCode === "400") {
            // Error
            errorMsg = res.data.responseMessage || 'Error in fetching list';
            notifyFailed(errorMsg);
          } else {
            // Unknown Error
            errorMsg = 'Unknown Error in fetching';
            notifyFailed(errorMsg);
          }
        } else {
          errorMsg = 'Unknown Error';
          notifyFailed(errorMsg);
        }
      }).catch(err => {
        setModalLoading(false);
        errorMsg = 'Internal Server Error';
        notifyFailed(errorMsg);
      });
  }


  const changeStatus = (val) => {
    var value = val;
    setBankTypeFiler(value);
  }

  const setListDataWrapper = (resp) => {
    let arr = setListData(resp);
    if (arr && arr.length) {
      setLoading(false);
    }
    if (searchText) {
      arr = getSearchHandle(searchText, arr);
    }
    setBankList(arr);
    setFilteredList(arr);
    let pc = Math.ceil(arr.length / pageSize);
    setPageCount(pc);
  }

  const setListData = (resp) => {
    let arr = [];
    for (let i = 0; i < resp.length; i++) {
      if (resp[i].accountType === bankTypeFilter) {
        arr.push(resp[i]);
      }
    }
    return arr;
  }

  const reloadList = () => {
    setSearchText('');
    setRefresh(true);
  }

  const reloadListHandle = () => {
    fetchBank();
  }

  const getBlockText = () => {
    let str = 'block';
    if (deleteObj.isBlocked) {
      str = 'unblock';
    }
    return `Do you want to ${str} ${deleteObj.bankName} bank ?`;
  }

  const sortHandle = (fieldValue, fieldName) => {
    let newValue = 0;
    if (fieldValue == "0") {
      newValue = '1';
    } else if (fieldValue == "1") {
      newValue = '2';
    } else if (fieldValue == "2") {
      newValue = '1';
    }
    setSort({ ...sortIS, [fieldName]: newValue });
  }

  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  }

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                {/* <h3 className="mb-0">Card tables</h3> */}

                <Form className="form-inline mr-3 d-md-flex ml-lg-auto"
                  onSubmit={e => { e.preventDefault(); }}>

                  <FormGroup>
                    <label
                      for="status"
                      className="form-control-label">
                      Account type
                    </label>
                    &nbsp; &nbsp;
                    <div class="dropdown-border">
                      <Input
                        type="select"
                        id="status"
                        className="form-control-alternative status-filter"
                        name="bankTypeFilter"
                        value={bankTypeFilter}
                        onChange={(e) => changeStatus(e.target.value)}
                      >
                        {BANKTYPE.map(c =>
                          <option key={c.key} value={c.key}>{c.value}</option>
                        )}
                      </Input>
                    </div>
                  </FormGroup>

                  &nbsp; &nbsp;

                  <FormGroup className="mb-0 navbar-search ">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input className="search-cls" placeholder="Search"
                        type="text"
                        value={searchText}
                        onChange={(e) => getSearch(e.target.value)}
                      />
                    </InputGroup>
                  </FormGroup>

                  &nbsp;&nbsp;

                  {privileges.add &&
                    <Button className="my-4" color="primary"
                      size="md"
                      onClick={openModal}>
                      Add Bank
                    </Button>}

                  <Button
                    color="primary"
                    onClick={reloadList}
                    size="sm"
                    style={btnCss}
                    data-toggle="tooltip"
                    title="Refresh">
                    <i class="fas fa-redo fa-lg" style={iconCss}></i>
                  </Button>

                </Form>


              </CardHeader>

              <Modal isOpen={open}
                style={{ width: "70vw", maxWidth: "70vw" }}>
                <ModalBody style={{ padding: 0 }}>
                  <Bank closeModal={closeModal} />
                </ModalBody>
              </Modal>

              <Modal
                isOpen={view}
                style={{ width: "70vw", maxWidth: "70vw" }}
              >
                <ModalBody style={{ padding: 0 }}>
                  <ViewBank closeModal={closeViewModal} {...bankObj} />
                </ModalBody>
              </Modal>

              <Modal
                isOpen={openEdit}
                style={{ width: "70vw", maxWidth: "70vw" }}
              >
                <ModalBody style={{ padding: 0 }}>
                  <EditBank closeModal={closeEditModal} {...editObj} />
                </ModalBody>
              </Modal>

              <Modal isOpen={openDelModal} className="modal-sm">
                <ModalHeader className="bg-white border-0">
                  <h3 className="mb-0">
                    {deleteObj && deleteObj.isBlocked ? 'Unblock Bank' : 'Block Bank'}
                  </h3>
                </ModalHeader>

                <ModalBody>
                  <div>
                    {deleteObj && deleteObj.bankName ?
                      <div>
                        <p className="text-left">
                          {getBlockText()}
                        </p>
                        <div className="text-right">
                          <Button color="primary" onClick={deleteBank} disabled={modalLoading}>
                            Yes {modalLoading && <i class="fa fa-spinner fa-spin"></i>}
                          </Button>{' '}
                          <Button color="secondary" disabled={modalLoading}
                            onClick={closeDeleteModal}>No</Button>
                        </div>
                      </div> : <> </>
                    }
                  </div>
                </ModalBody>
              </Modal>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col"
                      onClick={() => sortHandle(sort.sortName, 'sortName')}>
                      Bank Name
                      <button style={btnCss} >
                        <i className={getSortCls(sort.sortName)}
                          onClick={() => sortHandle(sort.sortName, 'sortName')}
                        />
                      </button>
                    </th>
                    <th scope="col"
                      onClick={() => sortHandle(sort.sortEmail, 'sortEmail')}>
                      Email
                      <button style={btnCss} >
                        <i className={getSortCls(sort.sortEmail)}
                          onClick={() => sortHandle(sort.sortEmail, 'sortEmail')}
                        />
                      </button>
                    </th>
                    <th scope="col"
                      onClick={() => sortHandle(sort.sortPhone, 'sortPhone')}>
                      Phone
                      <button style={btnCss} >
                        <i className={getSortCls(sort.sortPhone)}
                          onClick={() => sortHandle(sort.sortPhone, 'sortPhone')}
                        />
                      </button>
                    </th>
                    <th scope="col">Account type</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.length > 0 && filteredList.map((mmo, i) => {
                    return (
                      <tr>
                        <th scope="row">
                          {mmo.bankName}
                        </th>
                        <td>{mmo.contactEmail}</td>
                        <td>({mmo.contactMobileCode}) - {mmo.contactMobileNumber}</td>
                        <td>{mmo.accountType}</td>
                        <td>
                          {privileges.view && <Button
                            color="primary"
                            onClick={() => showBank(mmo)}
                            size="sm"
                            style={btnCss}
                            data-toggle="tooltip"
                            title="View"
                          >
                            <i class="fas fa-eye fa-lg" style={iconCss}></i>
                          </Button>}

                          {privileges.edit && <Button
                            color="primary"
                            onClick={() => fetchBankById(mmo.id)}
                            size="sm"
                            style={btnCss}
                            data-toggle="tooltip"
                            title="Edit">
                            <i class="fas fa-edit fa-lg" style={iconCss}></i>
                          </Button>}

                          {!mmo.isBlocked && privileges.block && <Button
                            color="primary"
                            onClick={() => openDelete(mmo)}
                            size="sm"
                            style={btnCss}
                            data-toggle="tooltip"
                            title="Block">
                            <i class="fa fa-eye-slash fa-lg" style={iconCss}></i>
                          </Button>}

                          {mmo.isBlocked && privileges.unblock &&
                            <Button
                              color="primary"
                              onClick={() => openDelete(mmo)}
                              size="sm"
                              style={btnCss}
                              data-toggle="tooltip"
                              title="Unblock">
                              <i class="fa fa-eye-slash fa-lg" style={{ color: "#FF0000" }}></i>
                            </Button>}

                          {/* {!mmo.isBlocked ?
                            <Button
                              color="primary"
                              onClick={() => openDelete(mmo)}
                              size="sm"
                              style={btnCss}
                              data-toggle="tooltip"
                              title="Block">
                              <i class="fa fa-eye-slash fa-lg" style={iconCss}></i>
                            </Button>
                            :
                            <Button
                              color="primary"
                              onClick={() => openDelete(mmo)}
                              size="sm"
                              style={btnCss}
                              data-toggle="tooltip"
                              title="Unblock">
                              <i class="fa fa-eye-slash fa-lg" style={{ color: "#FF0000" }}></i>
                            </Button>
                          } */}


                        </td>
                      </tr>

                    )
                  }
                  )}
                </tbody>
                {loading && <FullPageLoader label={"Fetching..."} />}
                {!loading && !filteredList.length && <NoRecordFound />}
              </Table>
              <CardFooter className="py-4">
                {filteredList.length > 0 &&
                  <Row>
                    <Col lg="6">
                      <div>
                        <small>
                          <strong>
                            Total Records : {totalRec}
                          </strong>
                        </small>
                      </div>
                    </Col>

                    <Col lg="6" >
                      <nav aria-label="...">
                        <div className="float-right">
                          <ReactPaginate
                            previousLabel={"prev"}
                            nextLabel={"next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pagesCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            onPageChange={handlePageClick}
                            containerClassName={"paginationV2"}
                            subContainerClassName={"pages paginationV2"}
                            activeClassName={"active"}
                            forcePage={currentPage} />
                        </div>
                      </nav>

                    </Col>
                  </Row>}
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default BankList;
